// src/components/auth/AuthLoading.tsx
import React from "react";

export const AuthLoading: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900 flex items-center justify-center">
      <div className="text-center">
        {/* Animated Logo Placeholder */}
        <div className="relative mb-8">
          <div className="w-24 h-24 mx-auto">
            <div className="absolute inset-0 bg-purple-500/20 rounded-full animate-ping" />
            <div className="absolute inset-0 bg-purple-600/30 rounded-full animate-ping animation-delay-200" />
            <div className="relative flex items-center justify-center w-full h-full bg-gray-800/80 backdrop-blur-xl rounded-full border border-purple-500/20">
              <div className="text-4xl font-bold text-purple-400">Λ</div>
            </div>
          </div>
        </div>

        {/* Loading Text */}
        <h2 className="text-xl sm:text-2xl font-semibold text-white mb-2">
          Authenticating...
        </h2>
        <p className="text-gray-400 text-sm sm:text-base">
          Verifying your credentials
        </p>

        {/* Loading Bar */}
        <div className="mt-8 w-64 mx-auto">
          <div className="h-1 bg-gray-700 rounded-full overflow-hidden">
            <div className="h-full bg-gradient-to-r from-purple-500 to-pink-500 rounded-full animate-loading-bar" />
          </div>
        </div>
      </div>
    </div>
  );
};
